/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Role_Admin_DescInputs */



/**
* | output |
* | --- |
* | "Manages members, groups and settings" |
*
* @param {Team_Manager_Role_Admin_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_role_admin_desc = /** @type {((inputs?: Team_Manager_Role_Admin_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Role_Admin_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gère les membres, groupes et paramètres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwaltet Mitglieder, Gruppen und Einstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestisce membri, gruppi e impostazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управляет участниками, группами и настройками")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gestiona miembros, grupos y ajustes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("管理成员、群组和设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メンバー・グループ・設定を管理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्य, समूह और सेटिंग्स प्रबंधित करता है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gere membros, grupos e definições")
	return /** @type {LocalizedString} */ ("Manages members, groups and settings")
});